import { Modal } from '../../../../../components'
import { leaveTypeDetailsAddI } from '../../../../holidays/components/types'
import './index.css'

const ViewTimeOffDetail = ({
    show,
    onClose,
    leaveTypeDetails,
}: leaveTypeDetailsAddI) => {
    return (
        <Modal
            show={show}
            handleClose={() => onClose(false)}
            title={'Leave Type Details'}
            customWidth={false}
            body={
                <div className="timeoff-details">
                    <h3>{leaveTypeDetails?.leaveTypeTitle} Details</h3>
                    <div className="details-section">
                        <div className="details-item">
                            <span>Number of leaves</span>
                            <span>
                                {leaveTypeDetails?.numberOfLeaves} Days/Year
                            </span>
                        </div>
                        <div className="details-item">
                            <span>Carry Over</span>
                            <span>
                                {leaveTypeDetails?.isCarryOver === true
                                    ? 'Yes'
                                    : 'No'}
                            </span>
                        </div>
                        <div className="details-item">
                            <span>Unlimited</span>
                            <span>
                                {' '}
                                {leaveTypeDetails?.isUnlimited === true
                                    ? 'Yes'
                                    : 'No'}
                            </span>
                        </div>
                        <div className="details-item">
                            <span>Prorata</span>
                            <span>
                                {leaveTypeDetails?.isProRata === true
                                    ? 'Yes'
                                    : 'No'}
                            </span>
                        </div>
                    </div>
                </div>
            }
            onSuccess={() => {
                onClose(false)
            }}
        />
    )
}
export default ViewTimeOffDetail
